module.exports = __webpack_public_path__ + "img/fo.b0073c90.svg";